import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { useSpring, animated } from 'react-spring';
import { Waypoint } from 'react-waypoint';
import styled from 'styled-components';
import { transparentize } from 'polished';
import CallToAction from 'ui/components/CallToAction';

import ScheduleImg from 'resources/img/schedule.png';

const ScheduleContainer = styled.div`
  overflow: hidden;
  padding: 40px 0;
  background-color: ${transparentize(0.9, '#9fbfff')};

  @media only screen and (max-width: ${p => p.theme.breakpoints.sm - 1}px) {
    padding: 1rem 0;

    button {
      text-align: center;
    }
  }
`;

const ScheduleContentWrapper = styled(animated.div)`
  display: flex;
  align-items: center;
  height: 319px;

  @media only screen and (max-width: ${p => p.theme.breakpoints.sm - 1}px) {
    display: block;
    height: 100%;
    padding: 0 0 0 0;

    div > div {
      justify-content: left;
    }
  }
`;

const ScheduleHeader = styled.h2`
  font-size: 25px;
  font-weight: bold;
  line-height: 1.2;
  color: #191919;
  padding-bottom: 1rem;

  span {
    text-decoration: underline;
    text-decoration-color: #0a7ef9;
  }

  @media only screen and (max-width: ${p => p.theme.breakpoints.sm - 1}px) {
    max-width: unset;
    padding-top: 1rem;
  }
`;

const ScheduleDesc = styled.h2`
  max-width: 421px;
  font-family: ProductSans;
  font-size: 18px;
  line-height: 1.22;
  color: #757575;
  padding-bottom: 31px;

`;

const ScheduleAnimatedImg = styled(animated.img)`
  height: 319px;
  width: 565px;

  @media only screen and (max-width: ${p => p.theme.breakpoints.sm - 1}px) {
    padding: 2rem 0;
    width: calc(414px - 2rem);
    height: 266px;
  }
`;

const Schedule = props => {
  const [isContentVisible, setContentIsVisible] = React.useState(false);

  const leftCardStyleProps = useSpring({
    opacity: isContentVisible ? 1 : 0,
    transform: isContentVisible ? `translateX(0px)` : `translateX(-200px)`,
  });
  const rightCardStyleProps = useSpring({
    opacity: isContentVisible ? 1 : 0,
    transform: isContentVisible ? `translateX(0px)` : `translateX(200px)`,
  });

  return (
    <Waypoint
      scrollableAncestor={window}
      topOffset="10%"
      bottomOffset="35%"
      onEnter={() => setContentIsVisible(true)}
      onLeave={() => setContentIsVisible(false)}
    >
      <ScheduleContainer>
        <Container>
          <Grid container>
            <Grid item xs={12} lg={6}>
              <ScheduleContentWrapper style={leftCardStyleProps}>
                <div>
                  <ScheduleHeader>
                    Get your personalized demo <span>With</span> Insent
                  </ScheduleHeader>
                  <ScheduleDesc>
                    Schedule a time with our team to learn how you can start building relationships
                    with your prospects today.
                  </ScheduleDesc>
                  <CallToAction />
                </div>
              </ScheduleContentWrapper>
            </Grid>
            <Grid item xs={12} lg={6}>
              <ScheduleAnimatedImg style={rightCardStyleProps} src={ScheduleImg} alt="schedule" />
            </Grid>
          </Grid>
        </Container>
      </ScheduleContainer>
    </Waypoint>
  );
};

Schedule.propTypes = {};

export default Schedule;
